import React from 'react'
import { Icon, l } from '@ds/index'
import cx from 'classnames'

import { Feature } from 'common/billing/components/SubscriptionSuccessModal/features'

import cm from './PriceBreakdownList.module.css'

interface PriceBreakdownListProps {
  features: Feature[]
  className?: string
}

export const PriceBreakdownList = ({ features, className }: PriceBreakdownListProps) => {
  return (
    <div className={cx(cm.features, className)} aria-label={l.translate('Features included')}>
      {features.map((feature, index) => (
        <React.Fragment key={index}>
          <div className="d-flex justify-between w-full">
            <div className={cm.feature}>
              <span>
                {Boolean(feature?.icon) && (
                  <span className={cm.featureIcons}>
                    <span className={cm.ai} role="img" aria-label={l.translate('Feature icon')}>
                      {feature.icon}
                    </span>
                  </span>
                )}
                <span className="text-body-sm">{l.getString(feature.title)}</span>
                <span>
                  {Boolean(feature.tooltip) && (
                    <>
                      <span
                        className={cm.featureTooltip}
                        data-title-at="right"
                        data-title={l.getString(feature.tooltip)}
                      >
                        <Icon.Question className="text-secondary" size={12} aria-hidden="true" />
                      </span>
                      <span className="visually-hidden">{l.getString(feature.tooltip)}</span>
                    </>
                  )}
                </span>
              </span>
              {Boolean(feature.note) && (
                <span className="text-body-sm text-secondary m-l-md">
                  {l.getString(feature.note)}
                </span>
              )}
            </div>
            <div>
              <span className="text-body-sm">
                <b>{l.getString(feature.value)}</b>
              </span>
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  )
}
